import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=18c6e297&scoped=true"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"
import style0 from "./SearchContent.vue?vue&type=style&index=0&id=18c6e297&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6e297",
  null
  
)

export default component.exports